/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Accept_CheckboxInputs */



/**
* | output |
* | --- |
* | "I understand and accept responsibility for configuring and using the Guardrails feature." |
*
* @param {Guardrails_Accept_CheckboxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_accept_checkbox = /** @type {((inputs?: Guardrails_Accept_CheckboxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Accept_CheckboxInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ich habe verstanden und übernehme die Verantwortung für Konfiguration und Nutzung der Guardrails-Funktion.")
	return /** @type {LocalizedString} */ ("I understand and accept responsibility for configuring and using the Guardrails feature.")
});